export var DayOfTheWeek;
(function (DayOfTheWeek) {
    DayOfTheWeek[DayOfTheWeek["sunday"] = 0] = "sunday";
    DayOfTheWeek[DayOfTheWeek["monday"] = 1] = "monday";
    DayOfTheWeek[DayOfTheWeek["tuesday"] = 2] = "tuesday";
    DayOfTheWeek[DayOfTheWeek["wednesday"] = 3] = "wednesday";
    DayOfTheWeek[DayOfTheWeek["thursday"] = 4] = "thursday";
    DayOfTheWeek[DayOfTheWeek["friday"] = 5] = "friday";
    DayOfTheWeek[DayOfTheWeek["saturday"] = 6] = "saturday";
})(DayOfTheWeek || (DayOfTheWeek = {}));
export var RecurrenceRuleFrequency;
(function (RecurrenceRuleFrequency) {
    RecurrenceRuleFrequency[RecurrenceRuleFrequency["daily"] = 0] = "daily";
    RecurrenceRuleFrequency[RecurrenceRuleFrequency["weekly"] = 1] = "weekly";
    RecurrenceRuleFrequency[RecurrenceRuleFrequency["monthly"] = 2] = "monthly";
    RecurrenceRuleFrequency[RecurrenceRuleFrequency["yearly"] = 3] = "yearly";
})(RecurrenceRuleFrequency || (RecurrenceRuleFrequency = {}));
//# sourceMappingURL=definitions.js.map